var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoUserManagement24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_user_management",
    d: "M46.175,723.653A3.547,3.547,0,1,1,42.76,727.2,3.482,3.482,0,0,1,46.175,723.653Zm1.437,11.136a5.388,5.388,0,0,1,1.175-3.365.992.992,0,0,0-.524.2,3.322,3.322,0,0,1-4.248-.02.941.941,0,0,0-.814-.189,6.175,6.175,0,0,0-3.758,5.339c-.093.833.348,2.864,6.662,2.894a16.939,16.939,0,0,0,3.915-.361A5.427,5.427,0,0,1,47.612,734.789Zm9.1-.357.5-.286a.421.421,0,0,0,.156-.579l-.953-1.633a.43.43,0,0,0-.585-.155l-.5.287a.431.431,0,0,1-.585-.152.419.419,0,0,1-.059-.215v-.575a.425.425,0,0,0-.428-.424H52.355a.426.426,0,0,0-.428.424h0v.575a.429.429,0,0,1-.643.367l-.5-.287a.432.432,0,0,0-.586.155l-.953,1.633a.422.422,0,0,0,.157.579l.5.286a.423.423,0,0,1,0,.735l-.5.286a.423.423,0,0,0-.157.58l.953,1.632a.432.432,0,0,0,.586.155l.5-.287a.43.43,0,0,1,.584.152.422.422,0,0,1,.059.215v.575a.426.426,0,0,0,.428.424h1.907a.426.426,0,0,0,.428-.424h0V737.9a.43.43,0,0,1,.644-.367l.5.287a.43.43,0,0,0,.585-.155l.953-1.632a.423.423,0,0,0-.156-.58l-.5-.286a.422.422,0,0,1-.156-.58A.429.429,0,0,1,56.715,734.432Zm-3.406,1.626A1.258,1.258,0,1,1,54.58,734.8h0A1.264,1.264,0,0,1,53.309,736.058Z",
    transform: "translate(-39.433 -723.653)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoUserManagement24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_user_management24x24.8e52878f29bb77023e49602521328780.svg";